import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/intervals/all',
    method: 'Get'
  })
}

